//
//
//
//
//

export default {
	name: 'blank-layout'
}
